import * as types from '../constants/actionTypes';
import * as underwriterActions from "../graphql/actions/underwriter";
import {addNotification as notify} from 'reapop';
import l10n from "../l10n/localization";
import * as selected from "./selected";
import * as creationActions from "./creation";
import * as ajaxRoutes from "../constants/ajaxRoutes";
import * as authHandler from "../utils/authHandler";



export function fetchUnderwriters(force = false) {
    return dispatch => {
        dispatch(loading());
        underwriterActions.getUnderwriters(
            function(response) {
                dispatch(receiveUnderwriters(response.data.underwriters));
            },
            function(error) {
                dispatch(notify({message: error.message, status: 'error'}));
            },
            force
        );
    }
}

export function add(underwriter, selectNewItem = false) {
    return dispatch => {
        dispatch(loading());
        dispatch(saving(underwriter));
        underwriterActions.add(
            function (response) {
                if (selectNewItem === true) {
                    dispatch(selected.selectedUnderwriter(response.data.createCompany))
                }

                dispatch(saved(response.data.createCompany));
                dispatch(notify({message: l10n.messages.success, status: 'success'}));
                dispatch(creationActions.receivednewlyCreatedUnderwriter(response.data.createCompany));
            },
            function (error) {
                dispatch(notify({message: error.message, status: 'error'}));
                dispatch(errorSaving());
            },
            underwriter
        );
    };
}


export function edit(underwriter) {
    let id = underwriter.id;
    delete underwriter.id;
    delete underwriter.__typename;
    delete underwriter.countryName;

    return dispatch => {
        dispatch(loading());
        dispatch(saving(underwriter));
        underwriterActions.edit(
            function (response) {
                dispatch(saved(response.data.editCompany));
                dispatch(notify({message: l10n.messages.success, status: 'success'}));
            },
            function (error) {
                dispatch(notify({message: error.message, status: 'error'}));
                dispatch(errorSaving());
            },
            id,
            underwriter
        );
    };
}

export function deleteUnderwriter(underwriterID) {
    return dispatch => {
        let url = ajaxRoutes.API_ROUTE + "/underwriter/delete/"+underwriterID;
        let headers = new Headers({"X-Authorization": 'Bearer ' + authHandler.getToken()});
        dispatch(deletingUnderwriter());
        fetch(url, {headers: headers})
            .then((response) => {
                if (!response.ok) {
                    throw Error(response.statusText);
                }
                dispatch(notify({message: l10n.messages.removed, status: 'success'}));
                return response;
            })
            .then(() => {
                dispatch(doneDeletingUnderwriter());
                dispatch(fetchUnderwriters(true));
            })
            .catch((error) => {
                dispatch(notify({message: error.message, status: 'error'}));
                dispatch(doneDeletingUnderwriter());
            });
    };
}

export function deletingUnderwriter(){
    return {
        type: types.DELETING_UNDERWRITER
    };
}

export function doneDeletingUnderwriter(){
    return {
        type: types.DONE_DELETING_UNDERWRITER
    };
}

export function loading() {
    return {
        type: types.LOADING_UNDERWRITER
    };
}


export function saving(underwriter) {
    return {
        type: types.SAVING_UNDERWRITER,
        payload: underwriter
    };
}

export function saved(underwriter) {
    return {
        type: types.SAVED_UNDERWRITER,
        payload: underwriter
    };
}

export function errorSaving() {
    return {
        type: types.ERROR_SAVING_UNDERWRITERS,
    };
}

export function receiveUnderwriters(data) {
    return {
        type: types.RECEIVED_UNDERWRITERS,
        payload: data
    };
}

export function errorMessage(message) {
    return dispatch => {
        dispatch(notify({message: message, status: 'error',dismissAfter: 8000}));
    };
}


// WEBPACK FOOTER //
// ./src/actions/underwriter.js